<template>
  <div class="com-box">
    <div class="com-title">
      <span class="main-title">图文详情</span>
      <span class="tips"><van-icon name="info-o" size="12" />建议单个图片≤2M</span>
    </div>
    <template v-if="imgList.length">
      <div class="img-item" v-for="(item, index) in imgList" :key="item.imgUrl">
        <van-image 
          v-if="item.detailDataType == 1"
          width="100%"
          height="auto"
          fit="cover"
          :src="item.moduleDetailValue"
        />
        <div class="empty-video-box" v-else>
          <van-icon name="play-circle-o" size="48"/>
        </div>

        <div class="del-img-btn" @click="deleteFile(item, index)">
          <van-icon class="del-icon" name="cross" size="12" />
        </div>
      </div>
    </template>
    <div class="btn-box">
      <van-uploader
        :before-read="beforeImgUpload" 
        :after-read="uploadImg">
        <van-button icon="photo-o" size="mini" :loading="isImgUploading" loading-text="上传中...">上传图片</van-button>
      </van-uploader>
    </div>
    <div class="btn-box">
      <van-uploader 
        accept="video/*"
        :before-read="beforeVideoUpload" 
        :after-read="uploadVideo">
        <van-button icon="video-o" size="mini" :loading="isVideoUploading" loading-text="上传中...">上传视频</van-button>
      </van-uploader>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: Array
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.initForm(newVal);
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      imgList: [],
      isImgUploading: false,
      isVideoUploading: false
    }
  },
  methods: {
    initForm(val) {
      if (val) {
        this.imgList = [...val];
      }
    },
    onFormChange() {
      const imgList = this.imgList.map((item, index) => ({
        ...item,
        sortNo: index
      }));
      this.$emit('change', imgList);
    },
    beforeImgUpload(file) {
      const acceptTypes = ['image/png', 'image/jpeg', 'image/gif'];
      if (!acceptTypes.includes(file.type)) {
        this.$toast('请上传png、jpg或gif格式图片');
        return false;
      }

      // const isLt5M = (file.size / 1024 / 1024) > 5;
      // if (isLt5M) {
      //   this.$toast('图片大小不能超过 5MB');
      //   return false;
      // }

      return true;
    },
    uploadImg(file) {
      this.isImgUploading = true;
      this.$api.common.uploadImg(file.file)
        .then(({data}) => {
          if (data && data[0]) {
            this.addFile(1, data[0].fileUrl);
          }
        })
        .finally(_ => {
          this.isImgUploading = false;
        });
    },
    beforeVideoUpload(file) {
      if (!file.type.toLowerCase().startsWith('video/')) {
        this.$toast('请上传合法格式的视频');
        return false;
      }

      // const isLt5M = (file.size / 1024 / 1024) > 5;
      // if (isLt5M) {
      //   this.$toast('图片大小不能超过 5MB');
      //   return false;
      // }

      return true;
    },
    uploadVideo(file) {
      this.isVideoUploading = true;
      this.$api.common.uploadVideo(file.file)
        .then(({data}) => {
          if (data) {
            this.addFile(2, data.fileUrl);
          }
        })
        .finally(_ => {
          this.isVideoUploading = false;
        });
    },
    addFile(type, fileUrl) {
      this.imgList.push({
        detailDataType: type,
        moduleDetailValue: fileUrl || '',
      });
      this.onFormChange();
    },
    isClone() {
      return this.$route.query.from == 'clone';
    },
    deleteFile(item, index) {
      let isClone = this.isClone()
      const param = {
        activityId: !isClone ? this.$route.query.activityId || '' : '',
        primaryKey: !isClone ? item.moduleDetailId || '' : '',
        imageUrl: item.moduleDetailValue,
        sourceType: 3
      };
      this.$api.common.deleteImg(param)
        .then(() => {
          this.imgList.splice(index, 1);
          this.onFormChange();
        });
    }
  }
}
</script>

<style lang="stylus" scoped>
.com-box
  margin 15px 0
  .com-title
    padding 15px 15px 0 15px;
    .main-title
      font-size 14px
      font-weight bold
      color #303133
    .tips
      margin-left 10px
      font-size 12px
      color #999
  .img-item
    box-sizing: border-box
    position relative
    margin 10px 15px
    padding 0
    background-color: #fff
    border-radius: 8px
    overflow hidden
    font-size 0
    .empty-video-box
      display: flex
      justify-content: center
      align-items: center
      width 100%
      height 165px
    .del-img-btn
      position absolute
      right 0
      top 0
      width 20px 
      height 20px
      background-color rgba(0, 0, 0, 0.7)
      border-radius 0 0 0 18px
      .del-icon
        top 3px
        right -5px
        color #fff
  .add-image
    margin 10px 15px
    padding 10px
    font-size 14px
    text-align: center
    background-color: #fff
    color #909399
    border-radius: 8px
  .btn-box
    margin 10px 15px
    padding: 10px 50px
    display: flex
    justify-content: space-around
    background-color: #fff
    border-radius: 8px
    >>> .van-button
      padding 0
      border none
      color #606266
      .van-icon
        font-size 16px

</style>